
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Retract from '@/components/widgets/retract/Retract.vue'
import StateMixin from '@/mixins/state'

@Component({
  components: {
    Retract
  }
})
export default class RetractCard extends Mixins(StateMixin) {
  @Prop({ type: Boolean, default: true })
  public enabled!: boolean

  get inLayout (): boolean {
    return (this.$store.state.config.layoutMode)
  }
}
